import React, { Component } from "react";
import {
    Button,
    TextField,
    Typography,
    Grid,
    Box,
    Stack,
    Tooltip,
} from "@mui/material";
import { styled } from "@mui/system";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from '@mui/icons-material/Image';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from "@mui/icons-material/Delete";


import { Header } from "../Header";
import { Footer } from "../Footer";
import { Navigate } from "react-router";
import Base from "../Base";

import { saveAs } from 'file-saver';


const DocumentBox = styled(Box)({
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "15px",
    background: "#f5f5f5",
    marginBottom: "20px",
    transition: "all 0.3s ease",
    width: "150px",
    height: "150px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "&:hover": {
        transform: "scale(1.02)",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
    },
});

const DocumentImage = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
});

class Archive extends Base {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            description: "",
            file: null,
            id: null,
            documents: [],
            data: null,
            titleError: "",
            descriptionError: "",
            loading: true,
        };
        this.fileInputRef = React.createRef();
    }
    componentDidMount() {
        fetch("api/v1/archive/list")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch documents");
                }
                return response.json();
            })
            .then((data) => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        documents: data.data,
                        loading: false,
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false,
                    });
                }
            })
            .catch((error) => {
                this.showErorrMessage("خطایی رخ داده است");
                this.setState({ error: error.message, loading: false });
            });
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        this.setState({ file });
    };

    handleSave = () => {
        const { title, description, file } = this.state;
        if (title && description && file) {


            const formData = new FormData();
            formData.append("title", this.state.title);
            formData.append("description", this.state.description);
            formData.append("file", this.state.file);


            this.httpPostFormData("api/v1/archive/create", formData)
                .then((data) => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        const { id } = data;

                        const newDocuments = [...this.state.documents];

                        const newDocument = {
                            title: title,
                            description: description,
                            file: file,
                            contentType: file.type,
                            id
                        };
                        newDocuments.push(newDocument);

                        this.setState({
                            documents: newDocuments,
                            title: "",
                            description: "",
                            files: [],
                            titleError: "",
                            descriptionError: "",
                        });

                        this.fileInputRef.current.value = "";

                        this.showSuccessMessage("با موفقیت ثبت شد");

                    } else {
                        this.showErorrMessage(data.message);
                        this.setState({
                            loading: false,
                        });
                    }
                })

            this.fileInputRef.current.value = "";
        } else {
            //if (!title) {
            //    this.setState({ titleError: "عنوان را وارد کنید" });
            //}

            if (!file) {
                alert("فایل را انتخاب کنید");
            }
        }
    };

    handleDelete = (index, id) => {

        var confirm = window.confirm("آیا از حذف این آیتم اظمینان دارید ؟");

        if (confirm) {

            this.httpPost("api/v1/archive/delete", { id })
                .then((data) => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {

                        const newDocuments = [...this.state.documents];
                        newDocuments.splice(index, 1);
                        this.setState({ documents: newDocuments });

                        this.showSuccessMessage("با موفقیت ثبت شد");

                    } else {
                        this.showErorrMessage(data.message);
                        this.setState({
                            loading: false,
                        });
                    }
                })
        }

    };

    getFilenameFromResponse(response) {
        const contentDisposition = response.headers.get('content-disposition');
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '');
        } else {
            return 'downloaded_file'; // Default filename if not found
        }
    }

    handleDownload = (id) => {


        fetch("api/v1/archive/download", {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {

            const fileName = this.getFilenameFromResponse(response);
            var blob = response.blob();

            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName || "downloaded-file";
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        }).catch(err => {
            console.log(err);
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });


    };

    renderForm() {
        const { title, description, documents, titleError, descriptionError } = this.state;
        const isSaveDisabled = !title || !description;

        return (
            <Box sx={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
                <Typography variant="h4" gutterBottom textAlign="right">
                    بارگذاری اسناد
                </Typography>
                <Grid container spacing={6} sx={{ mt: 2 }} justifyContent="center">
                    <Grid item xs={12} md={6}>

                        <div className="form-group">
                            <label className="form-label">عنوان</label>
                            <div className="form-control-wrap">
                                <input name="title" className="form-control" type="text" defaultValue={title} onChange={this.handleInputChange} />
                            </div>
                        </div>

                        <input name="file" type="file" accept="image/*,.pdf" onChange={this.handleFileChange} ref={this.fileInputRef} className="form-control" />

                    </Grid>
                    <Grid item xs={12} md={6}>

                        <div className="form-group">
                            <label className="form-label">توضیحات</label>
                            <div className="form-control-wrap">
                                <textarea name="description" className="form-control" type="text" defaultValue={description} onChange={this.handleInputChange} >
                                </textarea>
                            </div>
                        </div>

                    </Grid>
                </Grid>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSave}
                    disabled={isSaveDisabled}
                    sx={{ alignSelf: "center", width: "150px", marginTop: "10px" }}
                >
                    ذخیره
                </Button>
                <Grid container spacing={6} mt={2} justifyContent="center">
                    {documents.map((document, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <DocumentBox>
                                {document.contentType.startsWith("image") ? (
                                    <Box sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        height: "100%",
                                        background: "#fff",
                                        borderRadius: "10px",
                                    }}>

                                        <ImageIcon fontSize="large" />

                                    </Box>

                                ) : (
                                    <Box sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        height: "100%",
                                        background: "#fff",
                                        borderRadius: "10px",
                                    }}>

                                        <InsertDriveFileIcon fontSize="large" />

                                    </Box>
                                )}
                                <Box sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                    width: "100%",
                                }}>

                                    <Grid item>
                                        <Button onClick={() => this.handleDelete(index, document.id)}
                                            sx={{
                                                color: "red",
                                                "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.1)" },
                                                alignSelf: "flex-end",
                                            }}>

                                            <DeleteIcon fontSize="small" />

                                        </Button>

                                        <Button
                                            onClick={() => this.handleDownload(document.id)}
                                            sx={{
                                                color: "blue",
                                                "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.1)" },
                                                alignSelf: "flex-end",
                                            }}>
                                            <DownloadIcon fontSize="small" />
                                        </Button>
                                    </Grid>

                                    <Tooltip title={document.description} arrow>
                                        <Box
                                            sx={{
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                cursor: "default",
                                            }}
                                        >
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    textAlign: "right",
                                                    fontWeight: "bold",
                                                    marginBottom: "4px",
                                                    marginTop: "16px",
                                                }}
                                            >
                                                {document.title}
                                            </Typography>
                                        </Box>
                                    </Tooltip>
                                </Box>
                            </DocumentBox>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">{this.renderForm()}</div>
                    </div>
                </div>,
                <Footer />,
            ];

        return contents;
    }
}

export default Archive;
